<template>
  <div data-name="RoleCardMenu" data-node-id="15235:186917">
    <HorizontalMenu
      :items="menuItems"
      size="small"
      :bottomLine="false"
      :fixedTabs="false"
      :value="selectedTab"
      @onChange="handleTabChange"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue';
import HorizontalMenu from '@components/HorizontalMenu/HorizontalMenu.vue';

const props = defineProps({
  active_responsibilities_count: {
    type: Number,
    default: 0,
    validator: value => typeof value === 'number' && value >= 0
  },
  current_assignments_count: {
    type: Number,
    default: 0,
    validator: value => typeof value === 'number' && value >= 0
  },
  value: {
    type: Number,
    default: 0
  }
});
const emit = defineEmits(['tab-change']);

const selectedTab = computed(() => props.value);

const menuItems = computed(() => [
  { title: 'Purpose', count: null },
  { title: 'Responsibilities', count: props.active_responsibilities_count ?? 0 },
  { title: 'Assignments', count: props.current_assignments_count ?? 0 }
]);

function handleTabChange(value) {
  emit('tab-change', value);
}
</script>
